import { Permission } from '@tp-vision/roles-permissions';
import { t } from 'i18next';
import { useAuth } from '~auth/useAuth';
import { EmptyView, EmptyViewButton } from '~components/EmptyView';
import { EmptyPowerScheduleIllustration } from '~components/ui/illustrations';

export function EmptySchedules({ handleCreate }: { handleCreate: () => void }) {
  const { verifyUserPermissions } = useAuth();
  const hasScheduleCreatePermission = verifyUserPermissions([Permission.PowerscheduleCreate]);

  return (
    <EmptyView icon={<EmptyPowerScheduleIllustration />} title={t('createFirstSchedule')}>
      <EmptyViewButton
        onClick={handleCreate}
        label={t('createSchedule')}
        isDisabled={!hasScheduleCreatePermission}
      />
    </EmptyView>
  );
}
